// Bannerele alertelor de nivel, în colțul din dreapta jos.
//
// Când prețul atinge un nivel cu clopoțel, apare un banner cu moneda, bursa, nivelul și
// prețul de acum. Bannerul e o **legătură** reală spre Список наблюдения cu moneda aceea:
// clicul obișnuit deschide moneda aici, clicul cu rotița (sau Ctrl+clic) — într-un tab nou,
// fiindcă asta face browserul cu orice legătură. Rămâne până îl închizi cu ✕.
//
// Mai multe alerte se așază una peste alta, puțin suprapuse: cea mai nouă jos, întreagă;
// de la cele din spate se vede rândul de sus, cu numele monedei. Mouse-ul peste grup le
// desface pe toate.

import { el } from '../core/util.js';
import { iconMoneda, iconBursa } from './coin-icon.js';
import { icon } from './icons.js';
import { baseTicker } from './components.js';

const MAX = 6;

/** Adresa listei de urmărire cu moneda deschisă — aceeași pentru clic și pentru tab nou. */
export function watchUrl({ symbol, exchange, market }) {
  const q = new URLSearchParams({ symbol });
  if (exchange) q.set('exchange', exchange);
  if (market) q.set('market', market);
  return `/screener/coins/?${q}`;
}

function fmt(x) {
  const n = Number(x);
  if (!Number.isFinite(n)) return '—';
  const d = n >= 100 ? 2 : n >= 1 ? 4 : n >= 0.01 ? 6 : 8;
  return n.toFixed(d).replace(/0+$/, '').replace(/\.$/, '');
}

export class AlertBanners {
  /** @param {(info: {symbol, exchange, market}) => void} onOpen  clicul obișnuit */
  constructor(onOpen) {
    this.onOpen = onOpen;
    this.root = el('div', { class: 'ab-stack' });
    document.body.append(this.root);
  }

  /** O notificare `price_alert` de la server. */
  show(n) {
    const d = n.data || {};
    const symbol = n.symbol || '';
    if (!symbol) return;
    const info = { symbol, exchange: d.exchange || 'binance', market: d.market || 'futures' };
    const sus = d.price !== undefined && d.level !== undefined ? Number(d.price) >= Number(d.level) : null;
    const ora = new Date((n.ts || Date.now() / 1000) * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });

    const banner = el('a', {
      class: `ab${sus === null ? '' : sus ? ' up' : ' down'}`,
      href: watchUrl(info),
      title: 'Открыть в списке наблюдения · колёсиком мыши — в новой вкладке',
      // Doar clicul principal fără taste: Ctrl/Shift/rotița rămân ale browserului (tab nou).
      onclick: (e) => {
        if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;
        e.preventDefault();
        this.onOpen?.(info);
        this.#close(banner);
      },
    }, [
      el('div', { class: 'ab-head' }, [
        iconMoneda(symbol, 18),
        el('b', { class: 'ab-sym', text: baseTicker(symbol) }),
        el('span', { class: 'ab-ex' }, [iconBursa(info.exchange, 12)]),
        el('span', { class: 'ab-mkt', text: info.market === 'spot' ? 'спот' : 'фьючерсы' }),
        el('span', { class: 'ab-time', text: ora }),
        el('button', {
          class: 'ab-x', title: 'Закрыть',
          onclick: (e) => { e.preventDefault(); e.stopPropagation(); this.#close(banner); },
        }, [icon('close', 11)]),
      ]),
      el('div', { class: 'ab-body' }, [
        icon('bell', 11),
        el('span', { text: 'Уровень ' }),
        el('b', { text: fmt(d.level) }),
        el('span', { class: 'ab-dir', text: sus === null ? 'достигнут' : sus ? 'пробит вверх' : 'пробит вниз' }),
      ]),
      el('div', { class: 'ab-foot', text: d.price !== undefined ? `Цена сейчас ${fmt(d.price)}` : n.text || '' }),
    ]);
    this.root.append(banner);
    while (this.root.children.length > MAX) this.root.firstElementChild.remove();
    requestAnimationFrame(() => banner.classList.add('in'));
  }

  #close(banner) {
    banner.classList.remove('in');
    banner.classList.add('out');
    setTimeout(() => banner.remove(), 180);
  }
}
